module.exports = __webpack_public_path__ + "ipetbooking-landing/img/illustration01.3a031264.svg";